<template>
  <div class="grid_menu mb-5 pl-2">
    <v-card class="menu_team text-center">
      <router-link class="menu_team_link" to="/faqspage">
        <div class="menu_team_img">
          <img src="@/assets/faqs.png">
        </div>
        <div>
          คำถามที่พบบ่อย
        </div>
      </router-link>
    </v-card>
    <v-card class="menu_team text-center">
      <router-link class="menu_team_link" to="/logopage">
        <div class="menu_team_img">
          <img src="@/assets/logo_img.png">
        </div>
        <div>
          ตั้งค่าโลโก้แบรนด์สินค้า
        </div>
      </router-link>
    </v-card>
    <v-card class="menu_team text-center">
      <router-link class="menu_team_link" to="/policypage">
        <div class="menu_team_img">
          <img src="@/assets/policy.png">
        </div>
        <div>
          นโยบายความเป็นส่วนตัว
        </div>
      </router-link>
    </v-card>
    <v-card class="menu_team text-center">
      <router-link class="menu_team_link" to="/contractpage">
        <div class="menu_team_img">
          <img src="@/assets/contract.png">
        </div>
        <div>
          เงื่อนไขและข้อตกลง
        </div>
      </router-link>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MenuOther"
}
</script>

<style scoped>
.grid_menu {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 1180px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 50% 50%;
    /*grid-template-columns: 33.33% 33.33% 33.33%;*/
  }
}
@media only screen and (max-width: 500px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 100%;
  }
}
.menu_team{
  width: 97%;
}
.menu_team>.menu_team_link {
  color: #565656;
  padding: 10px 15px 10px 15px;
  line-height: 1.45;
  transition: padding 0.35s ease 0s !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: none;
  font-size: 20px;
}
.router-link-active,
.menu_team>.menu_team_link:hover {
  color: #fff !important;
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d)!important;
  transition: 0.1s !important;
  border-radius: 4px;
  font-weight: 400;
  height: 100%;
}

.menu_team_img {
  margin: auto;
  width: 50px;
}

.menu_team_img>img {
  max-width: 100%;
}
</style>
